(() => {
  'use strict';
  if (window.csFW26Initialized) return;
  window.csFW26Initialized = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  let pageActive = true;
  function load(video) {
    const sources = video.querySelectorAll('source[data-fw26-src]');
    if (!sources.length) return;
    sources.forEach(source => { source.src = source.dataset.fw26Src; source.removeAttribute('data-fw26-src'); });
    video.load();
  }
  function stop(video, state) {
    if (!video.paused) { state.internalPause = true; video.pause(); }
  }
  let winner = null, selectionFrame = 0;
  function update(video) {
    const state = states.get(video);
    if (!video.isConnected) { stop(video, state); observer.unobserve(video); states.delete(video); return; }
    if (winner !== video || !state.visible || document.hidden || !pageActive || state.userPaused ||
        (motion.matches && !state.manualPlay)) { stop(video, state); return; }
    if (state.pending || !video.paused) return;
    load(video);
    state.pending = true;
    Promise.resolve(video.play()).catch(() => { state.blocked = true; }).finally(() => {
      state.pending = false; paintToggle(video, state);
      if (winner !== video || !state.visible || document.hidden || !pageActive) stop(video, state);
    });
  }
  function updateAll() {
    const visible = [...states].filter(([video,state]) => video.isConnected && state.visible && !state.userPaused &&
      (!motion.matches || state.manualPlay));
    visible.sort(([a],[b]) => {
      const ar=a.getBoundingClientRect(),br=b.getBoundingClientRect();
      return Math.abs(ar.top+ar.height/2-innerHeight/2)-Math.abs(br.top+br.height/2-innerHeight/2);
    });
    winner = visible[0]?.[0] || null;
    states.forEach((state,video) => { if(video !== winner) stop(video,state); });
    if(winner) update(winner);
  }
  function scheduleSelection() {
    if(selectionFrame) return;
    selectionFrame=requestAnimationFrame(()=>{selectionFrame=0;updateAll();});
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => { const state=states.get(entry.target); if(state) state.visible=entry.isIntersecting && entry.intersectionRatio>=.15; });
    updateAll();
  }, {threshold:[0,.15,.5,.9]});
  function paintToggle(video,state) {
    if(!state.button) return;
    const playing=!video.paused;
    state.button.setAttribute('aria-label',playing?video.dataset.pauseLabel:video.dataset.playLabel);
    state.button.innerHTML=playing?'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M8 5v14M16 5v14"/></svg>':'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m8 5 11 7-11 7Z"/></svg>';
  }
  function setup(scope = document) {
    scope.querySelectorAll('[data-fw26-video]').forEach(video => {
      if (states.has(video)) return;
      const state = { visible:false, userPaused:false, internalPause:false, pending:false, manualPlay:false };
      states.set(video, state);
      video.controls = false; video.removeAttribute('controls'); video.disablePictureInPicture = true; video.disableRemotePlayback = true;
      video.tabIndex = -1;
      const button=document.createElement('button');
      button.type='button'; button.className='fw26-video-toggle'; state.button=button;
      video.parentNode.append(button);
      button.addEventListener('click',()=>{
        if(!video.paused){state.userPaused=true;state.manualPlay=false;stop(video,state);}
        else {state.userPaused=false;state.manualPlay=true;state.blocked=false;states.forEach((other,item)=>{if(item!==video) stop(item,other);});winner=video;update(video);}
        paintToggle(video,state);
      });
      paintToggle(video,state);
      video.autoplay = false; video.muted = true; video.defaultMuted = true; video.playsInline = true; video.loop = true;
      video.addEventListener('pause', () => { if (state.internalPause) state.internalPause=false; else if(state.visible && !document.hidden) state.userPaused=true; paintToggle(video,state); });
      video.addEventListener('play', () => { if (!state.pending) state.userPaused = false; if(winner !== video || !state.visible || document.hidden) stop(video,state); paintToggle(video,state); });
      observer.observe(video);

    });
    scope.querySelectorAll('[data-fw26]').forEach(root => {
      if (root.dataset.fw26Ready) return;
      root.dataset.fw26Ready = 'true';
      const dialog = root.querySelector('[data-fw26-lightbox]');
      let gallery = [], index = 0, returnFocus;
      function paint() {
        const source = gallery[index]; if (!source) return;
        const image = dialog.querySelector('[data-fw26-look]');
        const fullImage = new URL(source.currentSrc || source.src, location.href); fullImage.searchParams.delete('width');
        image.src = fullImage.href; image.alt = source.alt;
        dialog.querySelector('[data-fw26-count]').textContent = `${index + 1} / ${gallery.length}`;
      }
      root.addEventListener('click', event => {
        const trigger = event.target.closest('[data-gallery]');
        if (trigger && dialog) {
          gallery = [...root.querySelectorAll('[data-gallery]')].filter(x => x.dataset.gallery === trigger.dataset.gallery).map(x => x.querySelector('img'));
          index = gallery.indexOf(trigger.querySelector('img')); returnFocus = trigger; paint();
          dialog.toggleAttribute('data-fw26-pointer-focus', event.detail > 0);
          dialog.showModal();
        }
        if (event.target.closest('[data-fw26-close]')) dialog.close();
        if (event.target.closest('[data-fw26-prev]')) { index = (index - 1 + gallery.length) % gallery.length; paint(); }
        if (event.target.closest('[data-fw26-next]')) { index = (index + 1) % gallery.length; paint(); }
        const booking = event.target.closest('[data-booking]');
        if (booking?.dataset.showroom) {
          const select = document.querySelector('form[data-cs-lead-form] select[name="contact[showroom]"]');
          if (select && [...select.options].some(x => x.value === booking.dataset.showroom)) {
            select.value = booking.dataset.showroom; select.dispatchEvent(new Event('input', { bubbles: true })); select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
      if (dialog) {
        dialog.addEventListener('pointerdown', () => dialog.setAttribute('data-fw26-pointer-focus', ''));
        dialog.addEventListener('keydown', () => dialog.removeAttribute('data-fw26-pointer-focus'));
        dialog.addEventListener('close', () => returnFocus?.focus({ preventScroll: true }));
        dialog.addEventListener('click', e => { if (e.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); });
        dialog.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); index = (index + (e.key === 'ArrowRight' ? 1 : -1) + gallery.length) % gallery.length; paint(); } });
      }
      root.querySelectorAll('.material-option').forEach(detail => detail.addEventListener('toggle', () => { if (detail.open) root.querySelectorAll('.material-option').forEach(other => { if (other !== detail) other.open = false; }); }));
      root.querySelectorAll('[data-fw26-piece-gallery]').forEach(gallery => {
        const rail = gallery.querySelector('[data-fw26-frames]');
        const frames = [...rail.querySelectorAll('[data-fw26-frame]')];
        const thumbs = [...gallery.querySelectorAll('[data-fw26-media-index]')];
        const count = gallery.querySelector('[data-fw26-piece-count]');
        thumbs.forEach((button, index) => button.addEventListener('click', () => rail.scrollTo({left: index * rail.clientWidth, behavior: motion.matches ? 'auto' : 'smooth'})));
        let framePending = false;
        rail.addEventListener('scroll', () => {
          if (framePending) return;
          framePending = true;
          requestAnimationFrame(() => {
            framePending = false;
            const index = Math.min(frames.length - 1, Math.round(rail.scrollLeft / rail.clientWidth));
            count.textContent = `${String(index + 1).padStart(2, '0')} / ${frames.length}`;
            thumbs.forEach((button, i) => {if (i === index) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current');});
          });
        }, {passive: true});
      });
      if (root.matches('[data-fw26-catalog]')) {
        const cards = [...root.querySelectorAll('[data-fw26-product]')];
        const groups = [...root.querySelectorAll('[data-fw26-family]')];
        function applySelection() {
        const currentUrl = new URL(location.href);
        if (currentUrl.hash.startsWith('#pieces&')) {
          const legacy = new URLSearchParams(currentUrl.hash.slice(8));
          ['offer', 'family'].forEach(key => {
            if (!currentUrl.searchParams.has(key) && legacy.has(key)) currentUrl.searchParams.set(key, legacy.get(key));
          });
          currentUrl.hash = 'pieces';
          history.replaceState(history.state, '', currentUrl.href);
        }
        const params = new URL(location.href).searchParams;
        const offer = ['cm', 'rtw', 'atelier'].includes(params.get('offer')) ? params.get('offer') : 'all';
        const families = new Set(groups.map(group => group.dataset.fw26Family));
        const family = families.has(params.get('family')) ? params.get('family') : 'all';
        let count = 0;
        cards.forEach(card => {
          const matchesOffer = offer === 'all' || (offer === 'atelier'
            ? card.dataset.atelier === 'true'
            : card.dataset.offer === offer || card.dataset.offer === 'hybrid' || (offer === 'rtw' && card.dataset.offer === 'rtw_mto'));
          const matchesFamily = family === 'all' || card.closest('[data-fw26-family]')?.dataset.fw26Family === family;
          card.hidden = !(matchesOffer && matchesFamily);
          if (!card.hidden) count++;
        });
        groups.forEach(group => {
          const members = [...group.querySelectorAll('[data-fw26-product]')];
          group.hidden = !members.some(card => !card.hidden);
        });
        const selection = root.querySelector('[data-fw26-selection-status]');
        if (selection) selection.hidden = offer === 'all' && family === 'all';
        const status = root.querySelector('[data-fw26-results]');
        if (status) status.textContent = count + ' ' + (count === 1 ? status.dataset.labelOne : status.dataset.label);
        const empty = root.querySelector('[data-fw26-no-results]');
        if (empty) empty.hidden = count > 0 || !cards.length;
        const capsuleLink = root.querySelector('[data-fw26-capsule-link]');
        if (capsuleLink) {
          if (offer === 'atelier') capsuleLink.setAttribute('aria-current', 'page');
          else capsuleLink.removeAttribute('aria-current');
        }
        root.querySelectorAll('[data-fw26-family-link]').forEach(link => {
          if (link.dataset.fw26FamilyLink === family) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        }
        let landingTimer = 0;
        let landingTarget = null;
        let landingUntil = 0;
        let catalogUrl = location.href;
        function cancelCatalogLanding() {
          clearTimeout(landingTimer);
          landingTarget = null;
        }
        function alignCatalogLanding() {
          if (!landingTarget || !landingTarget.isConnected) {
            cancelCatalogLanding();
            return;
          }
          if (Date.now() > landingUntil) { clearTimeout(landingTimer); return; }
          const header = document.querySelector('.shopify-section--header');
          const headerRect = header?.getBoundingClientRect();
          let headerBottom = headerRect && headerRect.bottom > 0 && headerRect.top < 100 ? headerRect.bottom : 0;
          const absoluteTop = landingTarget.getBoundingClientRect().top + window.scrollY;
          if (header && typeof window.csDiscoveryBooking?.invitationAt === 'function') {
            const invitation = document.querySelector('[data-cs-invitation]');
            headerBottom = header.offsetHeight + (window.csDiscoveryBooking.invitationAt(absoluteTop) ? invitation?.offsetHeight || 0 : 0);
          }
          const targetY = Math.max(0, absoluteTop - headerBottom - 16);
          if (Math.abs(window.scrollY - targetY) > 2) window.scrollTo({top: targetY, behavior: 'instant'});
          clearTimeout(landingTimer);
          landingTimer = setTimeout(alignCatalogLanding, 100);
        }
        function landOnCatalogSelection() {
          cancelCatalogLanding();
          const hash = location.hash;
          if (hash === '#pieces') {
            const status = root.querySelector('[data-fw26-selection-status]');
            landingTarget = status && !status.hidden ? status : root.querySelector('.fw26-family-nav');
          } else {
            landingTarget = groups.find(group => '#' + group.id === hash && !group.hidden) || null;
          }
          if (!landingTarget) return;
          landingUntil = Date.now() + 1200;
          alignCatalogLanding();
        }
        root.addEventListener('click', event => {
          const link = event.target.closest('[data-fw26-capsule-link], [data-fw26-family-link], [data-fw26-reset]');
          if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;
          const destination = new URL(link.href, location.href);
          if (destination.origin !== location.origin || destination.pathname !== location.pathname) return;
          const url = new URL(location.href);
          ['offer', 'family'].forEach(key => {
            if (destination.searchParams.has(key)) url.searchParams.set(key, destination.searchParams.get(key));
            else url.searchParams.delete(key);
          });
          url.hash = destination.hash;
          event.preventDefault();
          if (url.href !== location.href) history.pushState(null, '', url.href);
          applySelection();
          catalogUrl = location.href;
          landOnCatalogSelection();
        });
        window.addEventListener('popstate', () => {
          if (catalogUrl === location.href) return;
          applySelection();
          catalogUrl = location.href;
          landOnCatalogSelection();
        });
        window.addEventListener('hashchange', landOnCatalogSelection);
        ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => {
          document.addEventListener(type, cancelCatalogLanding, {capture: true, passive: true});
        });
        window.addEventListener('pagehide', cancelCatalogLanding);
        function settleCatalogLayout() {
          if (!landingTarget) return;
          landingUntil = Date.now() + 600;
          alignCatalogLanding();
        }
        window.addEventListener('load', settleCatalogLayout, {once: true});
        if (document.fonts?.ready) document.fonts.ready.then(settleCatalogLayout);
        applySelection();
        catalogUrl = location.href;
        const navigationType = performance.getEntriesByType?.('navigation')[0]?.type;
        if (navigationType !== 'back_forward' && navigationType !== 'reload') landOnCatalogSelection();
      }
    });
  }
  window.addEventListener('scroll',scheduleSelection,{passive:true});
  document.addEventListener('visibilitychange', updateAll);
  window.addEventListener('pagehide', () => { pageActive = false; updateAll(); });
  window.addEventListener('pageshow', () => { pageActive = true; updateAll(); });
  motion.addEventListener('change', () => { if (motion.matches) states.forEach((state, video) => stop(video, state)); else updateAll(); });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true }); else setup();
})();

